export default function AdvantagesList()
{
    return (<section className="advantages-list">
            <div className="container-fluid">
                <div className="row desk">
                    <div className="col-3">
                        <a className="block" href="">
                            <div className="circle">
                                <i className="ico ico-car"/>
                            </div>
                            <p>Бесплатная доставка от 3 000 Р</p>
                        </a>
                    </div>
                    <div className="col-3">
                        <a className="block" href="">
                            <div className="circle">
                                <i className="ico ico-notebook"/>
                            </div>
                            <p>Скидка 5% при оплате онлайн</p>
                        </a>
                    </div>
                    <div className="col-3">
                        <a className="block" href="">
                            <div className="circle">
                                <i className="ico ico-discount"/>
                            </div>
                            <p>Цена ниже при оплате бонусами</p>
                        </a>
                    </div>
                    <div className="col-3">
                        <a className="block" href="">
                            <div className="circle">
                                <i className="ico ico-buyback"/>
                            </div>
                            <p>Лёгкий возврат в магазине</p>
                        </a>
                    </div>
                </div>
                <div className="row mob">
                    <div className="advantages-list__slider">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide block">
                                <div className="circle">
                                    <i className="ico ico-car"/>
                                </div>
                                <p>
                                    Бесплатная доставка
                                    <br/> от 3 000 Р
                                </p>
                            </div>
                            <div className="swiper-slide block">
                                <div className="circle">
                                    <i className="ico ico-notebook"/>
                                </div>
                                <p>Скидка 5% при оплате онлайн</p>
                            </div>
                            <div className="swiper-slide block">
                                <div className="circle">
                                    <i className="ico ico-discount"/>
                                </div>
                                <p>Цена ниже при оплате бонусами</p>
                            </div>
                            <div className="swiper-slide block">
                                <div className="circle">
                                    <i className="ico ico-buyback"/>
                                </div>
                                <p>
                                    Лёгкий возврат
                                    <br/> в магазине
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}